import React, { useEffect, useState } from "react";
import { NavigationButton, PrimaryButton } from "../../../Buttons";
import Label from "../../../Label";
import FormInputField from "../../../FormInputField";
import useSocCodes from "../../../../hooks/useSocCodes";
import SearchableCodeInput from "../../../SearchableCodeInput";

const EmployerInfo = ({ handleNext, handlePrev, formData, onChange }) => {
  const isFormValid = () => {
    return (
      formData.occupation_business &&
      formData.employer_business_name &&
      formData.job_title &&
      formData.applicant_annual_income_usd &&
      formData.employer_address &&
      formData.soc_code
    );
  };
  const socCodes = useSocCodes();
  const [selectedSoc, setSelectedSoc] = useState(null);

  useEffect(() => {
    if (formData.soc_code && socCodes.length > 0) {
      const found = socCodes.find(
        (item) => item.soc_code === formData.soc_code,
      );
      if (found) setSelectedSoc(found);
    }
  }, [formData.soc_code, socCodes]);

  const handleSocChange = (option) => {
    setSelectedSoc(option);
    onChange({ target: { name: "soc_code", value: option.soc_code } });
  };

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="md:col-span-2">
          <Label
            className="block text-sm font-bold text-text-primary mb-3"
            htmlFor="employer-info"
            text="Employer Information"
          />
        </div>

        <div className="md:col-span-2">
          <SearchableCodeInput
            label="Occupation code"
            placeholder="Search occupation"
            options={socCodes}
            selectedOption={selectedSoc}
            onChange={handleSocChange}
            codeKey="soc_code"
            titleKey="job_title"
          />
        </div>

        <div>
          <FormInputField
            label="Occupation / Business type"
            name="occupation_business"
            id="occupation_business"
            type="text"
            placeholder="Enter your occupation or business"
            value={formData.occupation_business}
            onChange={onChange}
          />
        </div>

        <div>
          <FormInputField
            label="Employer / Business name"
            name="employer_business_name"
            id="employer_business_name"
            type="text"
            placeholder="Enter your occupation or business name"
            value={formData.employer_business_name}
            onChange={onChange}
          />
        </div>

        <div>
          <FormInputField
            label="Job title"
            name="job_title"
            id="job_title"
            type="text"
            placeholder="Enter your job title"
            value={formData.job_title}
            onChange={onChange}
          />
        </div>

        <div>
          <FormInputField
            label="Estimated Gross Annual Income (USD)"
            name="applicant_annual_income_usd"
            id="applicant_annual_income_usd"
            type="number"
            placeholder="Enter your income in USD"
            value={formData.applicant_annual_income_usd}
            onChange={onChange}
          />
        </div>

        <div className="md:col-span-2">
          <FormInputField
            label="Address"
            name="employer_address"
            id="employer_address"
            type="text"
            placeholder="Enter your occupation or business address"
            value={formData.employer_address}
            onChange={onChange}
          />
        </div>
      </div>

      <hr className="border border-divider mb-4" />

      <div className="flex w-full justify-center">
        <div className="flex w-full md:w-96 space-x-4">
          <NavigationButton onClick={handlePrev} text="Back" />
          <PrimaryButton
            onClick={handleNext}
            text="Continue"
            disabled={!isFormValid()}
          />
        </div>
      </div>
    </div>
  );
};
export default EmployerInfo;
